import { z } from 'zod';

export const MediaFormatGroupAdminSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  sortOrder: z.number(),
  isActive: z.boolean(),
  formatCount: z.number(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type MediaFormatGroupAdmin = z.infer<typeof MediaFormatGroupAdminSchema>;

export const CreateFormatGroupSchema = z.object({
  code: z.string().min(1),
  name: z.string().min(1),
  sortOrder: z.number().int().default(0),
  isActive: z.boolean().default(true),
});
export type CreateFormatGroup = z.infer<typeof CreateFormatGroupSchema>;

export const UpdateFormatGroupSchema = z
  .object({
    name: z.string().min(1),
    sortOrder: z.number().int(),
    isActive: z.boolean(),
  })
  .partial()
  .strict();
export type UpdateFormatGroup = z.infer<typeof UpdateFormatGroupSchema>;

export const DeactivateFormatGroupEffectsSchema = z.object({
  roles: z.array(z.string()),
  activeFormatCount: z.number(),
});
export type DeactivateFormatGroupEffects = z.infer<typeof DeactivateFormatGroupEffectsSchema>;
